export enum PlaybookDetailLevel {
  Concise = "Concise",
  Normal = "Normal",
  Detailed = "Detailed",
}
